<template>
  <div>
    <component :is="formComponent" v-if="formComponent" />
    <generic-error v-else button-value="Back to profile" :button-to="profileUrl" />
  </div>
</template>

<script lang="ts">
import { careTypeRouteToGraphqlKey, isChildCareEditRoute } from './lib/careTypeUtils';
// General components
import GenericError from '@/components/generic_error/GenericError.vue';
import BioForm from './forms/general/BioForm.vue';
import EducationForm from './forms/general/EducationForm.vue';
import SpecialtySkillsForm from './forms/general/SpecialtySkillsForm.vue';
// Housekeeping specific
import HousekeepingRate from './forms/housekeeping/RateForm.vue';
import HousekeepingServices from './forms/housekeeping/ServicesForm.vue';
import HousekeepingExperience from './forms/housekeeping/ExperienceForm.vue';
// Pet care specific
import PetCareExperience from './forms/pet_care/ExperienceForm.vue';
import PetCareRate from './forms/pet_care/RateForm.vue';
import PetCareServices from './forms/pet_care/ServicesForm.vue';

type SectionRegistry = Record<string, any>;

const FORM_REGISTRY: Record<string, SectionRegistry> = {
  housekeeping: {
    bio: BioForm,
    rates: HousekeepingRate,
    services: HousekeepingServices,
    experience: HousekeepingExperience,
    education: EducationForm,
    'specialty-skills': SpecialtySkillsForm,
  },
  petCare: {
    bio: BioForm,
    education: EducationForm,
    experience: PetCareExperience,
    'specialty-skills': SpecialtySkillsForm,
    rates: PetCareRate,
    services: PetCareServices,
  },
};

export default {
  name: 'ProfileEditFormDispatcher',
  components: {
    GenericError,
  },
  props: {
    section: {
      type: String,
      required: true,
    },
  },
  computed: {
    careType(): string {
      return this.$route.params.care_type;
    },
    formComponent(): any {
      const group = isChildCareEditRoute(this.careType)
        ? 'childCare'
        : careTypeRouteToGraphqlKey[this.careType as keyof typeof careTypeRouteToGraphqlKey];
      return FORM_REGISTRY[group]?.[this.section] || null;
    },
    profileUrl(): string {
      const sitterUuid = this.$store.getters['account/getAccount']?.id;
      return `/provider/profile/${this.careType}/${sitterUuid}`;
    },
  },
};
</script>
